import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { RingGold, RingRose, RingWhite, RoseGold, SilverGold, YellowGold } from '../Images';
import { PropsFromScreenManager, TableData } from '../../types';
import { propertyMappings, source } from '../Diamond/useDiamond';
import { TooltipDataFetch } from '../Tooltip/TooltipDataFetch';
import { findNearestValue } from '../../Utils/findNearestCaratValue';
import { useMediaQuery } from 'react-responsive';
import { PropsFromStartWithSettingRedux } from './StartWithSetting';
import { getDiamondCode } from '../../Utils/getDiamondCode';
import { ringSettingParams } from "../../constant/generalData";
import CONSTANTS from "../../constant/general";
import { getBuildSearchParams, getDiamondId } from "../../Utils/general";
import HeaderConstant from "../../constant/HeaderConstant";

const swatches:{[key:string]:string} = {
    WG: SilverGold,
    RG: RoseGold,
    YG: YellowGold
}
const images:string[]  = [
    RingWhite,
    RingRose,
    RingGold
]
const sortOptions = [
    {label: 'Best Seller', value: 'best_seller'},
    {label: 'New Arrivals', value: 'new_arrivals'},
    {label: 'A - Z', value: 'name_ascending'},
    {label: 'Z - A', value: 'name_descending'},
    {label: 'Price: Low to High', value: 'price_low_to_high'},
    {label: 'Price: High to Low', value: 'price_high_to_low'}
];

const options = sortOptions.map(option => option.label);
const getApiValue = (displayLabel: string) => {
    const option = sortOptions.find(opt => opt.label === displayLabel);
    return option ? option.value : ''
};

const isClientSideSort = (displayLabel: string) => {
    const clientSideSortOptions = ['Price: Low to High', 'Price: High to Low'];
    return clientSideSortOptions.includes(displayLabel);
};

const createUniqueProductId = (product: any) => {
  return `${product.Code}-${product.ring_style}-${product.crown}-${product.side}-${product.side_stones}`
}

const useStartWithSetting = (props:PropsFromStartWithSettingRedux & PropsFromScreenManager) => {
    const {
        diamond,
        setIsShowFooter,
        setDiamondDetailsLoading,
        setDiamondDetailsSuccess,
        setDiamondDetailsFail,
        settingFilter,
        setFilterMinMaxProperty,
        setStartWithSettingFilterLoading,
        setStartWithSettingFilterFail,
        setStartWithSettingFilterSuccess,
        setResetStartWithSettingFilter,
        setStartWithSettingProductLoading,
        setStartWithSettingProductSuccess,
        setStartWithSettingProductFail,
        setTooltipDataLoading,
        SetTooltipDataSuccess,
        SetTooltipDataError,
        setAfterDiamondSelectOptions,
        instanceData:{screenManager},
        setSwatchColor,
        setExpandedRow,
        setRingOptions,
        setSelectedRingDetails,
        setStartWithSettingFilter,
        setSelectedDiamondLoading,
        setSelectedDiamondFail,
        setFilter,
        setOptionsByProduct,
        setSelectedProduct,
      setMaximumCaratSize,
        setHeaderTabToStud,
        footer,
    } = props;
    const [selectedImages, setSelectedImages] = useState<{[key:string | number]:{[key:string]:string}}>({});
    const [sortBy, setSortBy] = useState(options[0]);
    const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
    const [positionValue, setPositionValue] = useState<any[]>([]);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const isLargeTablet = useMediaQuery({query: "(max-width: 767px)"});
    const scrollRoot = useRef<HTMLDivElement>(null);
    const [showButton, setShowButton] = useState(false);
    const hasEffectRun = useRef(false);
    const currentUrl = window.location.href;
    const diamondId = getDiamondId(currentUrl);
    const isMobileLayout = useMediaQuery({ query: "(max-width: 767px)" });
    const [isChangeOptions,setIsChangeOptions] = useState(false);

    useEffect(() => {
            document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

  useEffect(() => {
    if (!!footer?.isShowFooter) {
      document.body.classList.add('sticky_filter');
    } else {
      document.body.classList.remove('sticky_filter');
    }
    return () => {
      if (!!footer?.isShowFooter) {
        document.body.classList.remove('sticky_filter');
      }
    };
  }, [footer?.isShowFooter]);

  const DetailsData = useCallback(async (id : string) => {
        setDiamondDetailsLoading();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_KEY}/?id='${id}'`);
            if (!response.ok) {
                setDiamondDetailsFail(new Error(`HTTP error! Status: ${response.status}`));
            }
            const result: TableData = await response.json();

            Object.keys(propertyMappings).forEach((property: string) => {
                result[property] = propertyMappings[property][result[property] as number  - 1];
            });
            const updatedResult: TableData = {
                ...result,
                source: result.source === 'GNU' ? source[0] : source[1],
                // diamond_price : result.diamond_price !== null ? `${result.diamond_price}` : '-'
            }
            if(Object.keys(updatedResult).length > 0){
                const {source,carat,shape} = updatedResult;
                const diamondDetail: { [key: string]: string } = {
                    type:source as string,
                    shape: shape as string,
                };
                getDiamondCodeData(diamondDetail,carat as number)
                setDiamondDetailsSuccess(updatedResult);
            }

            setIsShowFooter(true);
        } catch (e) {
            setDiamondDetailsFail(e);
        }
    },[diamondId,setDiamondDetailsSuccess, setDiamondDetailsLoading, setDiamondDetailsFail,fetch]);
    const getDiamondCodeData = useCallback(async(diamondDetail: { [key: string]: string },carat:number) => {
        const result = await getDiamondCode(diamondDetail,setSelectedDiamondLoading,setSelectedDiamondFail);
        const SelectedDiamondData = {
            ...result,
            Center_Diamond_Type: result.Diamond_Type,
            Center_Diamond_Size: findNearestValue(carat as number,true)
        }
        delete SelectedDiamondData.Diamond_Type;
        setAfterDiamondSelectOptions(SelectedDiamondData as {[key:string]:string|string[]});
    },[getDiamondCode,setSelectedDiamondLoading,setSelectedDiamondFail,findNearestValue,setAfterDiamondSelectOptions])
    const afterDiamondSelectOptions = useCallback(async () => {
      // setStartWithSettingFilter('Metal', '14');
        if(diamondId && Object.keys(diamond.details).length < 1){
          await DetailsData(diamondId as string);
        }else if(Object.keys(diamond.details).length > 0) {
            const {source,shape,carat} = diamond.details;
            const diamondDetail: { [key: string]: string } = {
                type:source as string,
                shape: shape as string,
            };
          await getDiamondCodeData(diamondDetail, carat as number)
        }
    },[diamondId,diamond.details,DetailsData,getDiamondCodeData])
    useEffect(()=>{
        afterDiamondSelectOptions();
    },[])

    useEffect(()=>{
        const newSelectedImages : {[key:string | number]:{[key:string]:string}} = {};
        settingFilter.products.forEach(product => {
            const uniqueId = createUniqueProductId(product)
            newSelectedImages[uniqueId] = {
                imagePath: product.images[settingFilter.options["Color"] as string] || product.images["DF"],
                swatch: settingFilter.options["Color"] as string
            }
        })
        setSelectedImages(newSelectedImages)
    },[settingFilter.options["Color"],settingFilter.products])

    const handleSwatchClick = useCallback(
        (uniqueProductId: string, image: string, key: string) => {
            setSelectedImages((prevState) => ({
                ...prevState,
                [uniqueProductId]: {
                    imagePath: image,
                    swatch: key,
                },
            }))
        },
        [setSelectedImages],
    )
    const urlData = useMemo(() => {
        return (screenManager as any).parseURL(window.location.href);
    }, [screenManager, window.location.href]);
  const isStuds = useMemo(() => urlData.command === 'stud-earrings', [ urlData ]);

    const getSettingOptions = useCallback(async () => {
        try {
          setStartWithSettingFilterLoading();
          const url = `${process.env.REACT_APP_SETTING_OPTIONS}${
            isStuds ? `?category=${CONSTANTS.STUD_CATEGORY_CODE}` : ''
          }`;
          const response = await fetch(url);
            if (!response.ok) {
                setStartWithSettingFilterFail(new Error(`HTTP error! Status: ${response.status}`));
            }
            const result = await response.json();
            setStartWithSettingFilterSuccess(result);
            // Update state with the data
        } catch (error: unknown) {
            setStartWithSettingFilterFail(error);
        }
    }, [ isStuds, fetch, setStartWithSettingFilterLoading, setStartWithSettingFilterFail, setStartWithSettingFilterSuccess ]);

    const handleDropdownToggle = useCallback(() => {
        setIsDropdownOpen((dropDown)=>{
            return !dropDown;
        });
        const bodyElement = document.body;
        if (bodyElement && bodyElement.classList.contains('tabbing')) {
            const children = document.querySelectorAll('#sortby_dropdown_options > li');
            for (let i = 0; i < children.length; i++) {
                const child = children[i] as HTMLElement;
                if (child.classList.length > 0) {
                    child.focus();
                }
            }
        }
    },[isDropdownOpen,setIsDropdownOpen])
    const handleOptionClick = useCallback((option:string) => {
        if (isClientSideSort(option)) {
            setIsChangeOptions(true);
        } else {
          setIsChangeOptions(false);
        }
        setSortBy(option);
        setIsDropdownOpen(false);
        handleCloseDropDown();
    },[setSortBy,setIsDropdownOpen,setIsChangeOptions]);

    const handleCloseDropDown = useCallback(() => {
        const bodyElement = document.body;
        if (bodyElement && bodyElement.classList.contains('tabbing')) {
            const element = document.querySelector("#sortby_dropdown_header") as HTMLElement | null;
            if (element) {
                element.focus();
            }
        }
    },[]);

    const handleClickOutside = useCallback((event:any) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
            if(isDropdownOpen){
                handleCloseDropDown();
            }
            setIsDropdownOpen(false);
        }
    },[isDropdownOpen, setIsDropdownOpen,dropdownRef.current]);

    const handleRESETFilters = useCallback(() => {
        setSortBy(options[0]);
        setResetStartWithSettingFilter(!isStuds);

    },[setResetStartWithSettingFilter,setSortBy,options])

    const getSettingProducts = useCallback(async (signal : AbortSignal) => {
      const queryParamsObject: Record<string, string | string[]> = { ...settingFilter.options };
      if (isStuds) {
        queryParamsObject["category"] = CONSTANTS.STUD_CATEGORY_CODE;
      }
        if (!isClientSideSort(sortBy)) {
            queryParamsObject['sort_by'] = getApiValue(sortBy);
        }
      if(Object.keys(diamond.details).length > 0){
          if(diamond?.details?.carat){
              queryParamsObject['Maximum_Carat_Size'] = `${(+diamond?.details?.carat * 100).toFixed()}`
          }
          if(/*diamond.details.certification === 'GCAL' &&*/ diamond.details.source !== 'Natural' && diamond.details.sustainable){
              queryParamsObject['Styles'] = `'Jenny Packham','Reve','Generic'`;
          }else if(/*diamond.details.certification === 'GCAL' &&*/ diamond.details.source !== 'Natural' && !diamond.details.sustainable){
              queryParamsObject['Styles'] = `'Jenny Packham','Generic'`;
          }else{
              queryParamsObject['Styles'] = `'Generic'`;
          }
      }
      //@ts-ignore
        const queryParams = new URLSearchParams(queryParamsObject).toString();
        try {
            setStartWithSettingProductLoading();
          const response = await fetch(`${process.env.REACT_APP_START_WITH_SETTING}?${queryParams}`, { signal });
            if (!response.ok) {
                setStartWithSettingFilterFail(new Error(`HTTP error! Status: ${response.status}`));
            }
            const result = await response.json();
              result.forEach((r: any) => {
                r.images = Object.entries(r.images).map(([key, value]) => {
                    return [key, value];
                }).reduce((acc, [key, value]) => {
                  //TODO TEMP SET ts-ignore
                  //@ts-ignore
                  acc[key] = value;
                  return acc;
                }, {});
              });

            setStartWithSettingProductSuccess(result);
            const prices = result.map((product:any) => product.price_at);
            const minValue = (prices.length > 0) ? Math.min(...prices) : 0;
            const maxValue = (prices.length > 0) ? Math.max(...prices) : 0;
            if(!Object.keys(settingFilter.options).includes("Setting_Price")){
                setFilterMinMaxProperty({
                    Setting_Price: {min : minValue, max: maxValue}
                })
            }

            setPositionValue(result);
        } catch (error: unknown) {
            setStartWithSettingProductFail(error);
        }
    }, [ isStuds, fetch, setStartWithSettingProductLoading, setStartWithSettingProductSuccess, setStartWithSettingProductFail, settingFilter.options, setPositionValue, setFilterMinMaxProperty, sortBy, diamond.details ]);
    useEffect(() => {
      const abortController = new AbortController();
      const signal = abortController.signal;
        const { options, isReset } = settingFilter;
        if (isChangeOptions) return;
        if (Object.keys(options).length > 0 || isReset) {
            getSettingProducts(signal);
            return () => {
              abortController.abort();
            }
        }
        if(isStuds){
          setStartWithSettingFilter('Center_Diamond_Size', '050');
        }else if (!diamondId) {
            setStartWithSettingFilter('Center_Diamond_Size', '200');
            /*const defaultSettings = {
                Center_Diamond_Size: '200',
                Metal: '14'
            };
            Object.entries(defaultSettings).forEach(([key, value]) => {
                setStartWithSettingFilter(key, value);
            });*/
        }
    }, [settingFilter.options, isChangeOptions,sortBy, settingFilter.isReset]);


    useEffect(() => {
        getSettingOptions();
    }, []);

    useEffect(()=>{
        const sortingProducts = settingFilter.products;
        if(sortBy === 'Price: Low to High'){
            setStartWithSettingProductLoading();
            sortingProducts.sort((a,b) => a.price_at - b.price_at);
            setStartWithSettingProductSuccess(sortingProducts)
        }else if(sortBy ==='Price: High to Low') {
            setStartWithSettingProductLoading();
            sortingProducts.sort((a,b) => b.price_at - a.price_at);
            setStartWithSettingProductSuccess(sortingProducts)
        }
    },[sortBy,settingFilter.products])

    useEffect(()=>{
        if(!hasEffectRun.current){
            TooltipDataFetch(setTooltipDataLoading,SetTooltipDataSuccess,SetTooltipDataError);
        }
        return () => {
            hasEffectRun.current = true;
        }
    },[hasEffectRun])

    const handleProduct = useCallback((code:string,product:{[key:string]:string|{[key:string]:string}}) => {
        setSelectedProduct(code);
        setMaximumCaratSize(product['Maximum_Carat_Size'] as string);
        const uniqueId = createUniqueProductId(product)
        const selectedSwatchValue = selectedImages[uniqueId].swatch;
        setSwatchColor(selectedSwatchValue)
        if(Object.keys(product).length > 0){
            Object.entries(product.default_options).forEach(([key,value]) => {
                if(!Object.keys(settingFilter.options).includes(key)){
                    setOptionsByProduct(key, value);
                }
            })
        }
        const params = {
          ...(product.type === CONSTANTS.DYO && {
              [ringSettingParams.Ring_Crown] : product[ringSettingParams.Ring_Crown],
              [ringSettingParams.Ring_Style] : product[ringSettingParams.Ring_Style],
              [ringSettingParams.Ring_Side] : product[ringSettingParams.Ring_Side]
          }),
              ...(product[ringSettingParams.Side_Stones] && {[ringSettingParams.Side_Stones] : product[ringSettingParams.Side_Stones]})
        }
      if (Object.keys(diamond.details).length > 0) {
        (screenManager as any).changeScreen({ viewName: (isStuds ? 'stud-earrings':'setting'), styleId: code, id: diamond.details.id, params , searchParams: getBuildSearchParams(window.location)});
      } else {
        (screenManager as any).changeScreen({ viewName: (isStuds ? 'stud-earrings':'setting'), styleId: code, params , searchParams: getBuildSearchParams(window.location)});
      }
    },[setSelectedProduct,setMaximumCaratSize,screenManager,diamond.details,settingFilter.options,selectedImages,setOptionsByProduct,setSwatchColor])

    const handleScroll = useCallback(() => {
        const div = scrollRoot.current;
        const threshold = 300;
        if (div) {
            const scrollY = div.scrollTop;
            setShowButton(scrollY > threshold);
        }
    },[setShowButton,scrollRoot.current]);

    useEffect(() => {
        const div = scrollRoot.current;
        if (div) {
            div.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (div) {
                div.removeEventListener('scroll', handleScroll);
            }
        };
    }, [scrollRoot.current,settingFilter.isLoading]);
    useEffect(()=>{
      setIsChangeOptions(false);
    },[settingFilter.options])

    const handleScrollforFocus = () => {
        if (scrollRoot.current && scrollRoot.current.scrollTop === 0) {
            scrollRoot.current.removeEventListener('scroll', handleScroll);
            const firstChild = document.querySelector("#listing_inner_grid > [tabindex='0']") as HTMLElement | null;
            if (firstChild) {
                firstChild.focus();
            }
        }
    };
    useEffect(() => {
        const handleTabPress = (event:any) => {
            if (event.key === 'ArrowLeft' || event.keyCode === 37) {
                event.preventDefault();
                const prevElement = event.target.previousElementSibling;
                if (prevElement && event.target.closest('#listing_inner_grid')) { // Check if prevElement exists
                    prevElement.focus();
                }
            } else if (event.key === 'ArrowRight' || event.keyCode === 39) {
                event.preventDefault();
                const nextElement = event.target.nextElementSibling;
                if (nextElement && event.target.closest('#listing_inner_grid')) { // Check if nextElement exists
                    nextElement.focus();
                }
            }
        };

        const handleMouseDown = () => {
            document.body.classList.remove('tabbing');
        };

        document.addEventListener('keydown', handleTabPress);
        document.addEventListener('mousedown', handleMouseDown);

        return () => {
            document.removeEventListener('keydown', handleTabPress);
            document.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);
    const handleScrollTopClick = useCallback((eve:any) => {
        if (scrollRoot.current) {
            scrollRoot.current.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
            scrollRoot.current.addEventListener('scroll', handleScrollforFocus);
            eve.stopPropagation();
        }
    }, [scrollRoot.current]);
  useEffect(() => {
    if (urlData?.command === 'stud-earrings') {
      setHeaderTabToStud([ HeaderConstant.STUD_STEP_1, HeaderConstant.STUD_STEP_2 ]);
    }
  }, [ urlData ]);

  useEffect(() => {
    if (
      settingFilter.selectedProduct &&
      settingFilter.scrollTop &&
      !settingFilter.isProductLoading &&
      !!document.querySelector(`div[id='scrollToTop']`)
    ) {
      document.querySelector(`div[id='scrollToTop']`)?.scrollIntoView({
        behavior: "smooth",
        block:    "center",
        inline:   "start",
      });
    }
  }, [ settingFilter.scrollTop, settingFilter.isProductLoading ]);

  const isReset = isStuds ? !(settingFilter.options["Center_Diamond_Size"]?.toString() === "050" &&  Object.keys(settingFilter.options).length === 1)   :  Object.keys(settingFilter.options).length >
    (Object.keys(settingFilter.afterDiamondSelectedOptions).length > 0
      ? 3
      : 1)
    return {
        dropdownRef,
        sortBy,
        isDropdownOpen,
        options,
        selectedImages,
        handleSwatchClick,
        handleDropdownToggle,
        handleRESETFilters,
        handleOptionClick,
        swatches,
        diamondId,
        isMobileLayout,
        handleProduct,
        handleClickOutside,
        handleScrollTopClick,
        isLargeTablet,
        showButton,
        scrollRoot,
        createUniqueProductId,
        isStuds,
        isReset
    }
}
export default useStartWithSetting;
